import { SVGProps, Ref, forwardRef } from 'react';

export const PhoneFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    d="M9.58 5.62 5.67 0c-9.204 2.598-5.905 11.027.712 17.64 6.616 6.614 15.013 9.877 17.618.683l-5.621-3.909-3.011 1.318c-.51.224-1.09.23-1.567-.057-.674-.406-1.745-1.157-3.02-2.432-1.281-1.281-2.034-2.355-2.438-3.028-.284-.472-.28-1.044-.064-1.55z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PhoneFilledSize24Glyph.displayName = 'PhoneFilledSize24Glyph';
